import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { PinnerSize } from './spinner.size';


@Component({
  selector: 'caremoni-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CareMoniSpinnerComponent {

  // @Input() inside: boolean = true;

  @Input() size: PinnerSize = 'medium';

  isFirstTime: boolean = false;

  @HostBinding('class.size-tiny')
  get tiny() {
    return this.size === 'tiny';
  }

  @HostBinding('class.size-giant')
  get giant() {
    return this.size === 'giant';
  }
}
